<template>
  <div class="page">
    <Navbar />
    <Banner :haSingleImg="false" :hasBgBlur="true" :galeria="noticia.galeria" />
    <v-container>
      <v-col>
        <v-row>
          <Title
            :sub1="noticia.categoria"
            :titulo="noticia.nome"
            :sub2="noticia.data"
            :hasVideo="hasVideo"
            :video="noticia.video"
          />
        </v-row>

        <v-row>
          <vue-simple-markdown class="body-1 text-justify" :source="noticia.descricao"></vue-simple-markdown>
        </v-row>
      </v-col>
    </v-container>
    <Footer/>
  </div>
</template>



<script>
import Navbar from "@/components/Navbar.vue";
import Title from "@/components/Title.vue";
import Footer from "@/components/Footer.vue";
import Banner from "@/components/Banner.vue";
import _ from "lodash";

export default {
  name: "Home",
  components: {
    Navbar,
    Banner,
    Title,
    Footer
  },
  destroyed() {
    this.noticia = {};
    this.id = null;
  },
  watch: {
    // call again the method if the route changes
    $route: "getData"
  },
  async mounted() {
    console.log("full path", this.$route.fullPath);
    await this.getData();
  },
  data() {
    return {
      id: this.$route.params.id,
      hasVideo: false,
      noticia: {},
      titulos: [],
      videoDialog: false
    };
  },
  methods: {
    async getData() {
      var _noticia = await this.$store.dispatch(
        "setNoticia",
        this.$route.params.id
      );
      console.log("noticia: ", _noticia);
      if (_.isNull(_noticia.video)) {
        this.hasVideo = false;
      } else {
        this.hasVideo = true;
      }
      this.noticia = _noticia;
    },
    btnShare(id) {
      var btnShare = document.getElementById(id);
      btnShare.click();
    }
  }
};
</script>
